import { useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { resetPassword, getErrorMessage } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPasswordForm({ token, onDone }) {
  const { lang, t } = useLang();
  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw1 !== pw2) { toast.error(t.passwordMismatch); return; }
    setBusy(true);
    try {
      await resetPassword(token, pw1);
      toast.success(t.passwordReset);
      onDone();
    } catch (err) {
      if (err?.response?.status === 429) toast.error(t.tooManyAttempts);
      else if (err?.response?.status === 400) toast.error(t.invalidResetToken);
      else toast.error(getErrorMessage(err));
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="reset-password-form">
      <h1 className={`${lang === "ar" ? "font-serif-ar" : "font-serif-en"} text-4xl text-[#0F5F63] font-semibold`}>
        {t.resetPasswordTitle}
      </h1>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <div>
          <Label htmlFor="rp1" className="text-xs uppercase tracking-widest text-[#5C6B6D]">{t.newPassword}</Label>
          <Input id="rp1" type="password" required minLength={6} value={pw1} onChange={(e) => setPw1(e.target.value)}
            data-testid="reset-pw1-input"
            className="mt-2 rounded-full bg-[#F4F2EB] border-0 focus-visible:ring-1 focus-visible:ring-[#0F5F63] h-12 px-5"
            autoFocus />
        </div>
        <div>
          <Label htmlFor="rp2" className="text-xs uppercase tracking-widest text-[#5C6B6D]">{t.confirmPassword}</Label>
          <Input id="rp2" type="password" required minLength={6} value={pw2} onChange={(e) => setPw2(e.target.value)}
            data-testid="reset-pw2-input"
            className="mt-2 rounded-full bg-[#F4F2EB] border-0 focus-visible:ring-1 focus-visible:ring-[#0F5F63] h-12 px-5" />
        </div>
        <Button type="submit" disabled={busy} data-testid="reset-submit-btn"
          className="w-full rounded-full h-12 bg-[#0F5F63] hover:bg-[#0A4548] text-[#FDFBF7] uppercase tracking-widest text-xs">
          {t.save}
        </Button>
      </form>
    </div>
  );
}
